import { MedicalServiceNameForReceipt } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { FormContextValues } from '@dreryk/react-common';

import { WithNameForReceipt } from './nameForReceipt.types';

export const nameForReceiptPartVisible = (
   controller: FormContextValues<any>,
   fiscalPrintEnabled: boolean
): controller is FormContextValues<WithNameForReceipt> => {
   return fiscalPrintEnabled;
};

export const getNameForReceipt = (
   nameForReceipt: MedicalServiceNameForReceipt,
   medicalServiceName: string,
   medicalServiceNameForInvoicing: string | undefined
): string => {
   switch (nameForReceipt.type) {
      case 'SAME_AS_STANDARD':
         return medicalServiceName;
      case 'SAME_AS_FOR_INVOICING':
         return medicalServiceNameForInvoicing ?? medicalServiceName;
      default:
         return nameForReceipt.value!;
   }
};
